globalThis.backoffice = globalThis.backoffice || {};

backoffice.ScreenshotUpdater = (function()
{
  function ScreenshotUpdater() {
    this.init();
  }

  ScreenshotUpdater.prototype = {
    init : function() {
        this.events();
    },
    events : function() {
        var me = this;
        $('body').on('click', '[data-update-screenshot-url]', function() {
            me.$button = $(this);
            me.ajax    = me.$button.data('update-screenshot-ajax');
            me.url     = me.$button.data('update-screenshot-url');
            me.$button.attr('disabled', 'disabled');
            me.getScreenshot();
        });
    },
    getScreenshot : function() {
        var me = this;
        $.post(this.ajax, { url : this.url }, function(data) {
            if(data.response == 1) {
                var $container = me.$button.parents(me.$button.data('container')),
                    $img       = $container.find('img');

                if($img.length > 0) {
                    $img.attr('src', data.screenshot)
                } else {
                    $('<img/>', {
                        src : data.screenshot
                    }).prependTo($container);
                }
                me.$button.removeAttr('disabled');

                $('body').trigger('screenshot-updater.updated', [data.screenshot]);
            } else {
                console.log('erreur');
            }
            backoffice.loader.finish();
        }).fail(function() {
            console.log('erreur');
        });
    }
  }

  return ScreenshotUpdater;
})();
